/**
 * Strawberry Bag — open/close + cart mutations.
 * Active when: theme force-on OR Intelligems class on <html>/<body>.
 * v2 class (or v2 force-on) wins over the current bag.
 * When inactive, Dawn/Kaching cart stays fully in control.
 */
(function () {
  var SECTION = 'strawberry-bag';
  var bag = null;
  var busy = false;
  var ignoreScrimUntil = 0;
  var mutatingFromBag = false;
  var closeTimer = null;
  var openTimerAnim = null;
  var openToken = 0;
  var PANEL_MS = 340;

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function hasClassToken(c) {
    if (!c) return false;
    if (document.documentElement.classList.contains(c)) return true;
    if (document.body && document.body.classList.contains(c)) return true;
    try {
      if (document.querySelector('.' + c)) return true;
    } catch (e) {}
    return false;
  }

  function probeBag() {
    return qs('[data-sb-bag]');
  }

  function igV2Class() {
    var el = probeBag();
    return (el && el.getAttribute('data-ig-v2-class')) || 'ig-conversion-cart-v2';
  }

  function igClass() {
    var el = qs('[data-sb-bag][data-sb-ver="1"]') || probeBag();
    return (el && el.getAttribute('data-ig-class')) || 'ig-conversion-cart';
  }

  function isV2Forced() {
    var el = qs('[data-sb-bag][data-sb-ver="2"]') || probeBag();
    return el && el.getAttribute('data-force-v2') === 'true';
  }

  function isV2Active() {
    return isV2Forced() || hasClassToken(igV2Class());
  }

  function getBag() {
    if (isV2Active()) {
      return qs('[data-sb-bag][data-sb-ver="2"]') || qs('[data-sb-bag]');
    }
    return qs('[data-sb-bag][data-sb-ver="1"]') || qs('[data-sb-bag]');
  }

  function isForced() {
    var el = qs('[data-sb-bag][data-sb-ver="1"]') || probeBag();
    return el && el.getAttribute('data-force') === 'true';
  }

  function hasIgClass() {
    return hasClassToken(igClass());
  }

  function isActiveVariant() {
    return isV2Active() || isForced() || hasIgClass();
  }

  function syncActiveState() {
    var v2on = isV2Active();
    var v1on = !v2on && (isForced() || hasIgClass());
    var v1 = qs('[data-sb-bag][data-sb-ver="1"]');
    var v2 = qs('[data-sb-bag][data-sb-ver="2"]');
    if (v1) v1.classList.toggle('is-active', v1on);
    if (v2) v2.classList.toggle('is-active', v2on);
    var on = v1on || v2on;
    document.documentElement.classList.toggle('sb-bag-on', on);
    document.documentElement.classList.toggle('sb-bag-v2', v2on);
    bag = getBag();
    return on;
  }

  function unlockScroll() {
    document.body.classList.remove(
      'overflow-hidden',
      'kaching-body__cart-open',
      'kaching-cart-open',
      'cart-open'
    );
    document.documentElement.classList.remove(
      'overflow-hidden',
      'kaching-cart-open',
      'kaching-body__cart-open'
    );
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('height');
    document.documentElement.style.removeProperty('overflow');
  }

  function deactivateDawnDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('active', 'animate');
    var overlay = drawer.querySelector('#CartDrawer-Overlay, .cart-drawer__overlay');
    if (overlay) overlay.style.pointerEvents = 'none';
  }

  function getPageDim() {
    var el = document.getElementById('sb-bag-page-dim');
    if (el || !document.body) return el;
    el = document.createElement('div');
    el.id = 'sb-bag-page-dim';
    el.setAttribute('data-sb-close', '');
    document.body.appendChild(el);
    el.addEventListener('click', function (event) {
      event.preventDefault();
      closeBag();
    });
    return el;
  }

  function paintOverlay(el, open) {
    if (!el || !el.style) return;
    if (open) {
      el.classList.add('is-open');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('position', 'fixed', 'important');
      el.style.setProperty('inset', '0px', 'important');
      el.style.setProperty('background', 'rgba(26, 26, 26, 0.48)', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('pointer-events', 'auto', 'important');
    } else {
      el.classList.remove('is-open');
      el.style.setProperty('opacity', '0', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
    }
  }

  function showPageDim(show) {
    var el = getPageDim();
    if (!el) return;
    if (show) {
      el.style.setProperty('z-index', '2147482998', 'important');
      if (el.parentNode !== document.body) document.body.appendChild(el);
    }
    paintOverlay(el, show);
  }

  function ensureOnBody(root) {
    if (root && document.body && root.parentNode !== document.body) {
      document.body.appendChild(root);
    }
  }

  function paintScrim(scrim, open) {
    if (!scrim) return;
    paintOverlay(scrim, open);
    if (open) {
      scrim.style.setProperty('z-index', '2147482998', 'important');
      scrim.style.setProperty('width', '100vw', 'important');
      scrim.style.setProperty('height', '100dvh', 'important');
      // Visual dim is #sb-bag-page-dim so the two layers don't stack.
      scrim.style.setProperty('background', 'transparent', 'important');
    }
  }

  function setLayer(root, visible) {
    if (!root) return;
    root.classList.toggle('is-visible', visible);
    document.documentElement.classList.toggle('sb-bag-open', visible);
    if (visible) {
      root.style.pointerEvents = 'none';
      root.style.background = 'transparent';
      var panel = root.querySelector('.sb-bag__panel');
      if (panel) {
        panel.style.pointerEvents = 'auto';
        panel.style.setProperty('z-index', '2147482999', 'important');
        panel.style.setProperty('position', 'fixed', 'important');
      }
    } else {
      root.style.removeProperty('pointer-events');
      root.style.removeProperty('background');
      var scrim = root.querySelector('.sb-bag__scrim');
      paintScrim(scrim, false);
      showPageDim(false);
    }
  }

  function setSlide(root, open) {
    if (!root) return;
    root.classList.toggle('is-open', open);
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    var scrim = root.querySelector('.sb-bag__scrim');
    paintScrim(scrim, open);
    showPageDim(open);
  }

  function setOpenClasses(root, open) {
    if (!root) return;
    if (open) {
      ensureOnBody(root);
      setLayer(root, true);
      setSlide(root, true);
    } else {
      setSlide(root, false);
    }
  }

  function openBag() {
    if (!syncActiveState()) return false;
    bag = getBag();
    if (!bag) return false;
    wantOpen = true;
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    if (openTimerAnim) {
      clearTimeout(openTimerAnim);
      openTimerAnim = null;
    }
    ignoreScrimUntil = Date.now() + 400;
    deactivateDawnDrawer();
    ensureOnBody(bag);
    bag.classList.add('is-active');
    setLayer(bag, true);
    document.body.classList.add('overflow-hidden');

    var scrim = bag.querySelector('.sb-bag__scrim');
    paintScrim(scrim, true);
    showPageDim(true);

    if (!bag.classList.contains('is-open')) {
      var token = ++openToken;
      bag.classList.remove('is-open');
      bag.setAttribute('aria-hidden', 'false');
      void bag.offsetWidth;
      openTimerAnim = setTimeout(function () {
        openTimerAnim = null;
        requestAnimationFrame(function () {
          if (token !== openToken) return;
          bag = getBag();
          if (!bag) return;
          bag.classList.add('is-open');
          bag.setAttribute('aria-hidden', 'false');
          paintScrim(bag.querySelector('.sb-bag__scrim'), true);
          showPageDim(true);
        });
      }, 20);
    }

    refreshBag();
    return true;
  }

  function finishClose() {
    bag = getBag();
    if (!bag || bag.classList.contains('is-open')) return;
    setLayer(bag, false);
  }

  function closeBag() {
    bag = getBag();
    wantOpen = false;
    openToken += 1;
    if (openTimerAnim) {
      clearTimeout(openTimerAnim);
      openTimerAnim = null;
    }
    if (bag) {
      setSlide(bag, false);
      var panel = bag.querySelector('.sb-bag__panel');
      if (panel) {
        var onEnd = function (event) {
          if (event.target !== panel) return;
          panel.removeEventListener('transitionend', onEnd);
          finishClose();
        };
        panel.addEventListener('transitionend', onEnd);
      }
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeTimer = null;
        finishClose();
      }, PANEL_MS);
    } else {
      document.documentElement.classList.remove('sb-bag-open');
    }
    showPageDim(false);
    deactivateDawnDrawer();
    unlockScroll();
    setTimeout(unlockScroll, 0);
    setTimeout(unlockScroll, 50);
  }

  function toggleBag() {
    bag = getBag();
    if (bag && bag.classList.contains('is-open')) {
      closeBag();
      return false;
    }
    return openBag();
  }

  window.openStrawberryBag = openBag;
  window.closeStrawberryBag = closeBag;
  window.toggleStrawberryBag = toggleBag;

  var wantOpen = false;

  function allBags() {
    return document.querySelectorAll('[data-sb-bag]');
  }

  function isBundlePending() {
    return window.strawberryBundlePending === true;
  }

  function checkoutRoots() {
    return document.querySelectorAll('[data-sb-bag], cart-drawer, .cart-drawer');
  }

  function isCheckoutControl(el) {
    if (!el || !el.matches) return false;
    return el.matches(
      'button[name="checkout"], input[name="checkout"], [data-sb-checkout], a[href*="/checkout"]'
    );
  }

  function syncCheckoutPending() {
    var pending = isBundlePending();
    var roots = checkoutRoots();
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (pending) {
        if (!root.hasAttribute('data-sb-pending-aria-busy')) {
          root.setAttribute('data-sb-pending-aria-busy', root.getAttribute('aria-busy') || '');
        }
        root.setAttribute('aria-busy', 'true');
      } else if (root.hasAttribute('data-sb-pending-aria-busy')) {
        var previousBusy = root.getAttribute('data-sb-pending-aria-busy');
        if (previousBusy) root.setAttribute('aria-busy', previousBusy);
        else root.removeAttribute('aria-busy');
        root.removeAttribute('data-sb-pending-aria-busy');
      }
    }

    var controls = document.querySelectorAll(
      '[data-sb-bag] button[name="checkout"], [data-sb-bag] input[name="checkout"], [data-sb-bag] [data-sb-checkout], [data-sb-bag] a[href*="/checkout"], cart-drawer button[name="checkout"], cart-drawer input[name="checkout"], cart-drawer [data-sb-checkout], cart-drawer a[href*="/checkout"], .cart-drawer button[name="checkout"], .cart-drawer input[name="checkout"], .cart-drawer [data-sb-checkout], .cart-drawer a[href*="/checkout"]'
    );
    for (var j = 0; j < controls.length; j++) {
      var control = controls[j];
      if (pending) {
        if (!control.hasAttribute('data-sb-pending-disabled')) {
          control.setAttribute('data-sb-pending-disabled', control.disabled ? 'true' : 'false');
        }
        if ('disabled' in control) control.disabled = true;
        if (!control.hasAttribute('data-sb-pending-aria-disabled')) {
          control.setAttribute('data-sb-pending-aria-disabled', control.getAttribute('aria-disabled') || '');
        }
        control.setAttribute('aria-disabled', 'true');
        control.classList.add('is-sb-pending-disabled');
        if (control.tagName === 'A') {
          if (!control.hasAttribute('data-sb-pending-tabindex')) {
            control.setAttribute('data-sb-pending-tabindex', control.getAttribute('tabindex') || '');
          }
          control.setAttribute('tabindex', '-1');
        }
      } else if (control.hasAttribute('data-sb-pending-disabled')) {
        if ('disabled' in control && control.getAttribute('data-sb-pending-disabled') === 'false') {
          control.disabled = false;
        }
        var previousAriaDisabled = control.getAttribute('data-sb-pending-aria-disabled');
        if (previousAriaDisabled) control.setAttribute('aria-disabled', previousAriaDisabled);
        else control.removeAttribute('aria-disabled');
        if (control.tagName === 'A') {
          var previousTabindex = control.getAttribute('data-sb-pending-tabindex');
          if (previousTabindex) control.setAttribute('tabindex', previousTabindex);
          else control.removeAttribute('tabindex');
          control.removeAttribute('data-sb-pending-tabindex');
        }
        control.classList.remove('is-sb-pending-disabled');
        control.removeAttribute('data-sb-pending-disabled');
        control.removeAttribute('data-sb-pending-aria-disabled');
      }
    }
  }

  function isCheckoutScope(el) {
    return el && el.closest && el.closest('[data-sb-bag], cart-drawer, .cart-drawer');
  }

  document.addEventListener('click', function (event) {
    if (!isBundlePending()) return;
    if (!event.target || !event.target.closest) return;
    var control = event.target.closest(
      'button[name="checkout"], input[name="checkout"], [data-sb-checkout], a[href*="/checkout"]'
    );
    if (control && isCheckoutScope(control) && isCheckoutControl(control)) stopEvent(event);
  }, true);

  document.addEventListener('submit', function (event) {
    if (!isBundlePending() || !isCheckoutScope(event.target)) return;
    var submitter = event.submitter;
    if (
      (submitter && isCheckoutControl(submitter)) ||
      event.target.querySelector('button[name="checkout"], input[name="checkout"], [data-sb-checkout]')
    ) {
      stopEvent(event);
    }
  }, true);

  function bindAllBags() {
    var nodes = allBags();
    for (var i = 0; i < nodes.length; i++) bindBag(nodes[i]);
    syncCheckoutPending();
  }

  function fillSocialProof(root) {
    if (!root) return;
    var el = root.querySelector('[data-sb-social]');
    if (!el) return;
    var tpl = el.getAttribute('data-sb-social-tpl') || '[count] people are checking out now';
    var key = 'sb-v2-social-n';
    var n = 0;
    try {
      n = parseInt(sessionStorage.getItem(key) || '', 10);
    } catch (e) {}
    if (!n || n < 90 || n > 180) {
      n = 110 + Math.floor(Math.random() * 51);
      try {
        sessionStorage.setItem(key, String(n));
      } catch (e2) {}
    }
    var html = tpl.replace('[count]', '<b>' + n + '</b>');
    var slot = el.querySelector('[data-sb-social-text]');
    if (slot) slot.innerHTML = html;
  }

  function swapBagVersion(ver, next) {
    if (!next) return;
    var cur = qs('[data-sb-bag][data-sb-ver="' + ver + '"]');
    if (!cur) return;
    cur.replaceWith(next);
  }

  async function refreshBag() {
    var current = getBag();
    if (!current && !probeBag()) return;
    var keepOpen =
      wantOpen ||
      (current && (current.classList.contains('is-open') || current.classList.contains('is-visible')));
    try {
      var res = await fetch(window.location.pathname + '?sections=' + SECTION);
      var json = await res.json();
      var html = json[SECTION];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nextV1 = doc.querySelector('[data-sb-bag][data-sb-ver="1"]');
      var nextV2 = doc.querySelector('[data-sb-bag][data-sb-ver="2"]');
      if (!nextV1 && !nextV2) {
        var next = doc.querySelector('[data-sb-bag]');
        if (!next || !current) return;
        current.replaceWith(next);
      } else {
        swapBagVersion('1', nextV1);
        swapBagVersion('2', nextV2);
      }

      syncActiveState();
      bag = getBag();
      bindAllBags();
      syncCheckoutPending();
      fillSocialProof(qs('[data-sb-bag][data-sb-ver="2"]'));
      if (keepOpen && bag) {
        document.body.appendChild(bag);
        setOpenClasses(bag, true);
        document.body.classList.add('overflow-hidden');
      }
      syncHeaderCountFromBag();
    } catch (e) {
      console.warn('[StrawberryBag] refresh failed', e);
    }
  }

  function isDispatchItem(item) {
    if (!item) return false;
    var handle = String(item.handle || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();
    var dispatchId = 0;
    var root = getBag();
    if (root) dispatchId = Number(root.getAttribute('data-dispatch-id') || 0);
    if (dispatchId && Number(item.variant_id) === dispatchId) return true;
    if (handle === 'kaching-cart-toggle') return true;
    if (title.indexOf('same day processing') !== -1) return true;
    if (title.indexOf('same-day dispatch') !== -1) return true;
    return false;
  }

  function visibleCartCount(cart) {
    if (!cart || !cart.items) return cart && cart.item_count ? Number(cart.item_count) : 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isDispatchItem(cart.items[i])) n += Number(cart.items[i].quantity) || 0;
    }
    return n;
  }

  function paintCartCount(n) {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    var wrap = icon.querySelector('.cart-count-bubble');
    n = Number(n) || 0;
    if (n > 0) {
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'cart-count-bubble';
        wrap.innerHTML =
          '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        icon.appendChild(wrap);
      }
      var visible = wrap.querySelector('span[aria-hidden="true"]');
      if (visible) visible.textContent = String(n);
      var hidden = wrap.querySelector('.visually-hidden');
      if (hidden) hidden.textContent = String(n);
    } else if (wrap) {
      wrap.remove();
    }
  }

  function syncHeaderCountFromBag() {
    bag = getBag();
    if (!bag) return;
    var n = bag.getAttribute('data-visible-count');
    if (n == null || n === '') return;
    paintCartCount(n);
  }

  async function refreshCartIcon() {
    try {
      var res = await fetch('/cart.js');
      var cart = await res.json();
      paintCartCount(visibleCartCount(cart));
    } catch (e) {}
  }

  function sellingPlanId(plan) {
    if (plan == null || plan === '') return '';
    var n = Number(plan);
    if (isFinite(n) && n > 0 && String(Math.trunc(n)) === String(plan).trim()) return Math.trunc(n);
    return plan;
  }

  async function cartPost(url, body) {
    busy = true;
    mutatingFromBag = true;
    bag = getBag();
    if (bag) bag.classList.add('is-busy');
    try {
      var res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        var detail = '';
        try {
          detail = await res.text();
        } catch (e) {}
        console.warn('[StrawberryBag] cart request failed', res.status, detail);
        return;
      }
      // Main removed elsewhere (qty/API) can leave a paid orphan brush.
      await purgeOrphanKachingGifts({ sweeps: 1, waitMs: 0 });
      await refreshBag();
      await refreshCartIcon();
      if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'strawberry-bag' });
        } catch (e) {}
      }
    } finally {
      busy = false;
      mutatingFromBag = false;
      bag = getBag();
      if (bag) bag.classList.remove('is-busy');
    }
  }

  // Remove a bag line. If it is a Kaching main, also remove gifts that share
  // its bundle id — otherwise the brush stays and becomes a paid line.
  async function removeLineWithLinkedGifts(lineEl) {
    var key = lineEl && lineEl.getAttribute('data-key');
    if (!key || busy || isBundlePending()) return;

    busy = true;
    mutatingFromBag = true;
    window.strawberryBundlePending = true;
    document.dispatchEvent(new CustomEvent('strawberry:bundle-pending'));
    bag = getBag();
    if (bag) bag.classList.add('is-busy');
    try {
      var cart = await subscriptionCartRequest('cart.js');
      var item = cart.items.find(function (line) { return line.key === key; });
      if (!item) {
        await refreshBag();
        return;
      }

      var bundle = parseBundleProperty(item.properties && item.properties.__kaching_bundles);
      var keys = [key];
      if (bundle && bundle.main && bundle.id) {
        cart.items.forEach(function (line) {
          var lineBundle = parseBundleProperty(line.properties && line.properties.__kaching_bundles);
          if (lineBundle && lineBundle.gift && lineBundle.id === bundle.id) keys.push(line.key);
        });
      }

      await removeItemsByKeys(keys);
      // EasyGift sometimes re-adds the brush after the main is gone — sweep again.
      await purgeOrphanKachingGifts({ force: true, sweeps: 3, waitMs: 250 });
      await refreshBag();
      await refreshCartIcon();
      if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'strawberry-bag' });
        } catch (e) {}
      }
    } catch (err) {
      console.error('[StrawberryBag] remove failed', err);
      await refreshBag();
      showSubscriptionError(getBag(), err.message || 'Could not update your cart.');
    } finally {
      busy = false;
      mutatingFromBag = false;
      window.strawberryBundlePending = false;
      document.dispatchEvent(new CustomEvent('strawberry:bundle-pending'));
      bag = getBag();
      if (bag) bag.classList.remove('is-busy');
    }
  }

  function bindBag(root) {
    if (!root || root.__sbBound) return;
    root.__sbBound = true;
    syncCheckoutPending();

    root.addEventListener('click', function (event) {
      if (busy) {
        event.preventDefault();
        return;
      }

      if (event.target.closest('[data-sb-close]')) {
        if (event.target.closest('.sb-bag__scrim') && Date.now() < ignoreScrimUntil) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        closeBag();
        return;
      }

      var qtyBtn = event.target.closest('[data-sb-qty]');
      if (qtyBtn) {
        event.preventDefault();
        var line = qtyBtn.closest('[data-sb-line]');
        if (!line || qtyBtn.disabled || line.getAttribute('data-gift') === 'true') return;
        var delta = Number(qtyBtn.getAttribute('data-sb-qty'));
        var qty = Number(line.getAttribute('data-qty') || 1) + delta;
        if (qty < 1) {
          removeLineWithLinkedGifts(line);
          return;
        }
        cartPost(window.routes.cart_change_url + '.js', {
          line: Number(line.getAttribute('data-index')),
          quantity: qty
        });
        return;
      }

      var removeBtn = event.target.closest('[data-sb-remove]');
      if (removeBtn) {
        event.preventDefault();
        var lineR = removeBtn.closest('[data-sb-line]');
        if (!lineR) return;
        removeLineWithLinkedGifts(lineR);
        return;
      }

      var subBtn = event.target.closest('[data-sb-subscribe]');
      if (subBtn) {
        event.preventDefault();
        var lineS = subBtn.closest('[data-sb-line]');
        if (!lineS || !lineS.getAttribute('data-key')) return;
        if (subBtn.classList.contains('on')) {
          switchToOneTime(root, lineS);
          return;
        }
        if (lineS.getAttribute('data-plan-default')) {
          switchToSubscription(root, lineS);
        }
        return;
      }

      var switchBtn = event.target.closest('[data-sb-switch-sub]');
      if (switchBtn) {
        event.preventDefault();
        switchToSubscription(root);
        return;
      }

      var addBtn = event.target.closest('[data-sb-add]');
      if (addBtn) {
        event.preventDefault();
        var id = addBtn.getAttribute('data-sb-add');
        cartPost(window.routes.cart_add_url + '.js', { id: Number(id), quantity: 1 });
        return;
      }

      var dispatchBtn = event.target.closest('[data-sb-dispatch]');
      if (dispatchBtn) {
        event.preventDefault();
        var key = dispatchBtn.getAttribute('data-key');
        var variant = dispatchBtn.getAttribute('data-variant');
        if (dispatchBtn.classList.contains('on') && key) {
          cartPost(window.routes.cart_change_url + '.js', { id: key, quantity: 0 });
        } else if (variant) {
          cartPost(window.routes.cart_add_url + '.js', { id: Number(variant), quantity: 1 });
        }
      }
    });
    fillSocialProof(root);
  }

  async function subscriptionCartRequest(path, payload) {
    var response = await fetch(window.Shopify.routes.root + path, payload ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    } : { cache: 'no-store' });
    var data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Could not update your subscription.');
    return data;
  }

  function kachingBundleNonce() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'kb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function copyLineProperties(properties) {
    var next = {};
    if (!properties) return next;
    Object.keys(properties).forEach(function (key) {
      if (properties[key] != null) next[key] = properties[key];
    });
    return next;
  }

  function parseBundleProperty(raw) {
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function lineHasKachingTag(item) {
    var raw = item && item.properties && item.properties.__kaching_bundles;
    if (raw == null || raw === '') return false;
    return !!parseBundleProperty(raw);
  }

  // Shopify cart/change cannot clear line properties with {}. Once a key exists,
  // blank it with "" — omitting the key or sending {} leaves the old value.
  function propertiesClearingKaching(properties) {
    var next = copyLineProperties(properties);
    next.__kaching_bundles = '';
    return next;
  }

  function propertiesRestoringOriginal(originalProperties) {
    var next = copyLineProperties(originalProperties);
    if (!(originalProperties && originalProperties.__kaching_bundles)) {
      next.__kaching_bundles = '';
    }
    return next;
  }

  async function changeLineSellingPlan(lineKey, quantity, sellingPlan, properties) {
    return subscriptionCartRequest('cart/change.js', {
      id: lineKey,
      quantity: quantity,
      selling_plan: sellingPlan == null ? '' : sellingPlan,
      properties: properties
    });
  }

  // Force-clear only the tag this flow just wrote. Never match by product /
  // variant alone — another KP subscription in the cart can share that id.
  async function ensureNoKachingTag(cart, options) {
    var matchTagString = options && options.matchTagString;
    var matchBundleId = options && options.matchBundleId;
    if (!matchTagString && !matchBundleId) return cart;

    var line = cart.items.find(function (item) {
      if (!lineHasKachingTag(item)) return false;
      var raw = item.properties.__kaching_bundles;
      if (matchTagString && raw === matchTagString) return true;
      if (!matchBundleId) return false;
      var bundle = parseBundleProperty(raw);
      return !!(bundle && bundle.id === matchBundleId);
    });
    if (!line) return cart;

    var sellingPlan = options.sellingPlan;
    if (sellingPlan == null) {
      sellingPlan = line.selling_plan_allocation
        ? line.selling_plan_allocation.selling_plan.id
        : '';
    }
    await changeLineSellingPlan(
      line.key,
      options.quantity != null ? options.quantity : line.quantity,
      sellingPlan,
      propertiesClearingKaching(options.baseProperties || line.properties)
    );
    return subscriptionCartRequest('cart.js');
  }

  function bundleIdFromItem(item) {
    var bundle = parseBundleProperty(item.properties && item.properties.__kaching_bundles);
    return bundle && bundle.id ? bundle.id : null;
  }

  // Only use a deal that belongs to this product — never the first deal on
  // whichever product page the bag happens to be open on.
  function parseKachingDealSettings(doc, dealId, productId) {
    var matches = Array.from(doc.querySelectorAll('script.kaching-bundles-deal-block-settings')).map(function (node) {
      try {
        return {
          settings: JSON.parse(node.textContent),
          productId: node.getAttribute('data-product-id')
        };
      } catch (e) {
        return null;
      }
    }).filter(Boolean);

    if (productId) {
      matches = matches.filter(function (entry) {
        return String(entry.productId) === String(productId);
      });
    }
    if (!matches.length) return null;

    if (dealId) {
      var byDeal = matches.find(function (entry) {
        return entry.settings.nanoId === dealId || entry.settings.id === dealId;
      });
      if (byDeal) return byDeal.settings;
    }
    var withBars = matches.find(function (entry) {
      return (entry.settings.dealBars || []).length;
    });
    return withBars ? withBars.settings : null;
  }

  function barHasSubscriptionGift(bar) {
    return (bar.freeGifts || []).some(function (gift) {
      return gift.giftType === 'product' && gift.applyOnlyForSubscriptions;
    });
  }

  function findSubscriptionGiftBar(dealBars, preferredId, itemQuantity) {
    var qty = Number(itemQuantity) || 1;
    var bars = (dealBars || []).filter(barHasSubscriptionGift);
    if (!bars.length) {
      if (preferredId) {
        return (dealBars || []).find(function (bar) { return bar.id === preferredId; }) || null;
      }
      return (dealBars && dealBars[0]) || null;
    }

    if (preferredId) {
      var preferred = bars.find(function (bar) {
        return bar.id === preferredId && Number(bar.quantity || 1) === qty;
      });
      if (preferred) return preferred;
    }

    var exactQty = bars.find(function (bar) { return Number(bar.quantity || 1) === qty; });
    if (exactQty) return exactQty;

    // Multiple quantity tiers but none match this line — don't guess.
    var distinctQtys = [];
    bars.forEach(function (bar) {
      var barQty = Number(bar.quantity || 1);
      if (distinctQtys.indexOf(barQty) === -1) distinctQtys.push(barQty);
    });
    if (distinctQtys.length > 1) {
      throw new Error('Please select your subscription offer on the product page.');
    }
    return bars[0];
  }

  function mapSubscriptionGifts(doc, bar, bundle, itemQuantity) {
    var gifts = (bar.freeGifts || []).filter(function (gift) {
      return gift.giftType === 'product' && gift.applyOnlyForSubscriptions;
    });
    return gifts.map(function (gift) {
      if (gift.excludeRatesAboveThreshold) {
        throw new Error('This gift requires selection on the product page.');
      }
      var productId = String(gift.productGID).split('/').pop();
      var productNode = doc.querySelector('script.kaching-bundles-product[data-product-id="' + productId + '"]');
      if (!productNode) throw new Error('The subscription gift is unavailable.');
      var product = JSON.parse(productNode.textContent);
      var choices = (product.variants || []).filter(function (variant) {
        return variant.availableForSale && (!gift.variantGIDs || !gift.variantGIDs.length ||
          gift.variantGIDs.some(function (id) { return String(id).split('/').pop() === String(variant.id); }));
      });
      if (choices.length !== 1) throw new Error('Please select your subscription gift on the product page.');
      var giftProps = { id: bundle.id, deal: bundle.deal, gift: gift.id };
      if (bundle.v) giftProps.v = bundle.v;
      return {
        id: choices[0].id,
        quantity: (gift.quantity || 1) * Math.ceil(itemQuantity / (bar.quantity || 1)),
        properties: {
          __kaching_bundles: JSON.stringify(giftProps)
        }
      };
    });
  }

  function plainSubscriptionUpgrade(property) {
    // No usable Kaching deal (empty app block, no gift, etc.) — just flip the plan.
    // Do not set previousBundleId: that path removes gifts, and a plain switch
    // is not a deal rebind.
    return {
      gifts: [],
      mainProps: null,
      mainPropsString: property || null,
      attachMain: false,
      previousBundleId: null
    };
  }

  async function loadProductKachingDoc(item) {
    var productId = item.product_id;
    var dealId = null;
    var existing = parseBundleProperty(item.properties && item.properties.__kaching_bundles);
    if (existing && existing.deal) dealId = existing.deal;

    // In-page deal only when it is tagged for this product and has real JSON.
    if (productId && document.querySelector(
      'script.kaching-bundles-deal-block-settings[data-product-id="' + productId + '"]'
    )) {
      var pageSettings = parseKachingDealSettings(document, dealId, productId);
      if (pageSettings) return { doc: document, settings: pageSettings };
    }

    var response = await fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(item.handle));
    // Failed fetch ≠ "no deal". Abort so KP/HP don't silently lose the free gift.
    if (!response.ok) throw new Error('Could not load the Kaching subscription offer.');
    var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    var settings = parseKachingDealSettings(doc, dealId, productId);
    if (!settings) {
      // Product page fetch is authoritative for this handle; allow untagged scripts.
      settings = parseKachingDealSettings(doc, dealId, null);
    }
    // Empty Kaching app blocks (e.g. eczema) return null — caller does a plain sub switch.
    return { doc: doc, settings: settings || null };
  }

  // Resolve free subscription gifts for a cart line. OTP lines have no
  // __kaching_bundles — attach main props on upgrade so Kaching can discount.
  async function subscriptionUpgrade(item) {
    var property = item.properties && item.properties.__kaching_bundles;
    var existing = parseBundleProperty(property);
    var loaded = await loadProductKachingDoc(item);
    var doc = loaded.doc;
    var settings = loaded.settings;
    if (!settings || !(settings.dealBars || []).length) {
      return plainSubscriptionUpgrade(property);
    }

    var preferredBarId = existing && (existing.bid || existing.bar);
    var bar = findSubscriptionGiftBar(settings.dealBars, preferredBarId, item.quantity);
    if (!bar) return plainSubscriptionUpgrade(property);

    var subscriptionGifts = (bar.freeGifts || []).filter(function (gift) {
      return gift.giftType === 'product' && gift.applyOnlyForSubscriptions;
    });
    // No sub gift on this deal — plain selling-plan switch, no Kaching tag.
    if (!subscriptionGifts.length) return plainSubscriptionUpgrade(property);

    var sameBar = existing && existing.main && (existing.bid === bar.id || existing.bar === bar.id);
    if (sameBar && settings.versionId && existing.v && settings.versionId !== existing.v) {
      throw new Error('This bundle offer has changed. Please add it again from the product page.');
    }

    var mainProps;
    var mainPropsString;
    var attachMain = false;
    if (sameBar) {
      mainProps = existing;
      // Keep the exact cart string — JSON.stringify can reorder keys.
      mainPropsString = property;
    } else {
      attachMain = true;
      mainProps = {
        deal: settings.nanoId || settings.id,
        pp: Number(item.product_id) || undefined,
        main: true,
        id: kachingBundleNonce(),
        bar: bar.id
      };
      if (settings.versionId) mainProps.v = settings.versionId;
      if (settings.marketId) mainProps.market = settings.marketId;
      mainPropsString = JSON.stringify(mainProps);
    }

    return {
      gifts: mapSubscriptionGifts(doc, bar, mainProps, item.quantity),
      mainProps: mainProps,
      mainPropsString: mainPropsString,
      attachMain: attachMain,
      previousBundleId: existing && existing.id && existing.id !== mainProps.id ? existing.id : null
    };
  }

  function giftQtyMatching(cart, gift) {
    return cart.items.filter(function (item) {
      return item.variant_id === gift.id && item.properties &&
        item.properties.__kaching_bundles === gift.properties.__kaching_bundles;
    }).reduce(function (sum, item) { return sum + item.quantity; }, 0);
  }

  async function removeItemsByKeys(keys) {
    var unique = [];
    (keys || []).forEach(function (key) {
      if (key && unique.indexOf(key) === -1) unique.push(key);
    });
    for (var i = 0; i < unique.length; i++) {
      await subscriptionCartRequest('cart/change.js', { id: unique[i], quantity: 0 });
    }
  }

  // Drop gift lines whose bundle main is gone (paid orphan brush).
  async function purgeOrphanKachingGifts(options) {
    if (isBundlePending() && !(options && options.force)) return;
    var sweeps = (options && options.sweeps) || 1;
    var waitMs = (options && options.waitMs) || 0;
    for (var s = 0; s < sweeps; s++) {
      if (s > 0 && waitMs > 0) {
        await new Promise(function (resolve) { setTimeout(resolve, waitMs); });
      }
      var cart = await subscriptionCartRequest('cart.js');
      var mainIds = {};
      cart.items.forEach(function (item) {
        var bundle = parseBundleProperty(item.properties && item.properties.__kaching_bundles);
        if (bundle && bundle.main && bundle.id) mainIds[bundle.id] = true;
      });
      var orphanKeys = cart.items.filter(function (item) {
        var bundle = parseBundleProperty(item.properties && item.properties.__kaching_bundles);
        return !!(bundle && bundle.gift && bundle.id && !mainIds[bundle.id]);
      }).map(function (item) { return item.key; });
      if (!orphanKeys.length) return;
      await removeItemsByKeys(orphanKeys);
    }
  }

  async function removeBundleGiftLines(cart, bundleId) {
    if (!bundleId) return cart;
    var keys = cart.items.filter(function (item) {
      var bundle = parseBundleProperty(item.properties && item.properties.__kaching_bundles);
      return bundle && bundle.gift && bundle.id === bundleId;
    }).map(function (item) { return item.key; });
    if (!keys.length) return cart;
    await removeItemsByKeys(keys);
    return subscriptionCartRequest('cart.js');
  }

  function variantIdInList(giftVariantIds, variantId) {
    return (giftVariantIds || []).some(function (id) {
      return String(id) === String(variantId);
    });
  }

  // Only remove paid lines that are Kaching gift-tagged for this bundle.
  // Never touch a brush the customer bought at full price (no gift props).
  async function removePaidKachingGiftLines(cart, giftVariantIds, bundleId) {
    var keys = cart.items.filter(function (item) {
      if (!variantIdInList(giftVariantIds, item.variant_id)) return false;
      if (item.final_line_price === 0) return false;
      var bundle = parseBundleProperty(item.properties && item.properties.__kaching_bundles);
      if (!bundle || !bundle.gift) return false;
      if (bundleId && bundle.id !== bundleId) return false;
      return true;
    }).map(function (item) { return item.key; });
    if (!keys.length) return cart;
    await removeItemsByKeys(keys);
    return subscriptionCartRequest('cart.js');
  }

  async function rollbackSubscriptionJob(job) {
    try {
      var cart = await subscriptionCartRequest('cart.js');
      // Drop gifts tied to the new nonce, and paid Kaching leftovers for that nonce only.
      if (job.mainProps && job.mainProps.id) {
        cart = await removeBundleGiftLines(cart, job.mainProps.id);
      }
      var giftVariantIds = (job.gifts || []).map(function (gift) { return gift.id; });
      if (giftVariantIds.length && job.mainProps && job.mainProps.id) {
        cart = await removePaidKachingGiftLines(cart, giftVariantIds, job.mainProps.id);
      }

      function matchRolledBackLine(item) {
        if (item.variant_id !== job.item.variant_id) return false;
        if (job.mainPropsString && item.properties &&
            item.properties.__kaching_bundles === job.mainPropsString) return true;
        return item.key === job.key;
      }

      var line = cart.items.find(matchRolledBackLine) || cart.items.find(function (item) {
        return item.variant_id === job.item.variant_id && !item.selling_plan_allocation;
      });

      if (line) {
        // If the OTP line had no tag, blank __kaching_bundles — {} would keep it.
        await changeLineSellingPlan(
          line.key,
          job.item.quantity,
          job.originalPlan || '',
          propertiesRestoringOriginal(job.originalProperties)
        );
        cart = await subscriptionCartRequest('cart.js');
        if (!(job.originalProperties && job.originalProperties.__kaching_bundles) && job.mainPropsString) {
          cart = await ensureNoKachingTag(cart, {
            matchTagString: job.mainPropsString,
            matchBundleId: job.mainProps && job.mainProps.id,
            quantity: job.item.quantity,
            sellingPlan: job.originalPlan || '',
            baseProperties: job.originalProperties
          });
        }
      }

      // Prior-bundle Kaching gifts that went paid after rebind — not customer purchases.
      if (job.previousBundleId && giftVariantIds.length) {
        cart = await subscriptionCartRequest('cart.js');
        await removePaidKachingGiftLines(cart, giftVariantIds, job.previousBundleId);
      }
    } catch (rollbackErr) {
      console.error('[StrawberryBag] subscription rollback failed', rollbackErr);
    }
  }

  function showSubscriptionError(root, message) {
    var error = root.querySelector('[data-sb-subscription-error]');
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('data-sb-subscription-error', '');
      error.setAttribute('role', 'alert');
      (root.querySelector('.ft') || root).prepend(error);
    }
    error.textContent = message;
    error.hidden = !message;
  }

  async function switchToOneTime(root, onlyLine) {
    var source = root || getBag();
    if (!source || busy || isBundlePending() || !onlyLine) return;
    var key = onlyLine.getAttribute('data-key');
    if (!key) return;

    busy = true;
    mutatingFromBag = true;
    window.strawberryBundlePending = true;
    document.dispatchEvent(new CustomEvent('strawberry:bundle-pending'));
    source.classList.add('is-busy');
    showSubscriptionError(source, '');
    try {
      var cart = await subscriptionCartRequest('cart.js');
      var item = cart.items.find(function (line) { return line.key === key; });
      if (!item) throw new Error('Your cart changed. Please refresh it and try again.');

      var bundleId = bundleIdFromItem(item);
      // Blank the key — delete/{} leaves the Kaching tag on the OTP line.
      cart = await changeLineSellingPlan(
        key,
        item.quantity,
        '',
        propertiesClearingKaching(item.properties)
      );
      cart = await removeBundleGiftLines(cart, bundleId);
      if (bundleId) {
        cart = await ensureNoKachingTag(cart, {
          matchBundleId: bundleId,
          quantity: item.quantity,
          sellingPlan: '',
          baseProperties: item.properties
        });
      }

      await refreshBag();
      await refreshCartIcon();
      if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'strawberry-bag' });
      }
    } catch (err) {
      console.error('[StrawberryBag] one-time switch failed', err);
      await refreshBag();
      showSubscriptionError(getBag() || source, err.message || 'Could not update your cart.');
    } finally {
      busy = false;
      mutatingFromBag = false;
      window.strawberryBundlePending = false;
      document.dispatchEvent(new CustomEvent('strawberry:bundle-pending'));
      bag = getBag();
      if (bag) bag.classList.remove('is-busy');
    }
  }

  async function switchToSubscription(root, onlyLine) {
    var source = root || getBag();
    if (!source || busy || isBundlePending()) return;
    var lines = onlyLine ? [onlyLine] : source.querySelectorAll('[data-sb-line][data-gift="false"]');
    var jobs = Array.from(lines).filter(function (line) {
      return !line.getAttribute('data-plan') && line.getAttribute('data-plan-default');
    }).map(function (line) {
      return { key: line.getAttribute('data-key'), plan: sellingPlanId(line.getAttribute('data-plan-default')) };
    });
    if (!jobs.length) return;

    busy = true;
    mutatingFromBag = true;
    window.strawberryBundlePending = true;
    document.dispatchEvent(new CustomEvent('strawberry:bundle-pending'));
    source.classList.add('is-busy');
    showSubscriptionError(source, '');
    var startedJobs = [];
    try {
      var cart = await subscriptionCartRequest('cart.js');
      // Resolve every gift before changing any line. Use keys, since changing
      // a selling plan can reorder cart lines or merge them.
      for (var i = 0; i < jobs.length; i++) {
        jobs[i].item = cart.items.find(function (item) { return item.key === jobs[i].key; });
        if (!jobs[i].item) throw new Error('Your cart changed. Please refresh it and try again.');
        jobs[i].originalProperties = copyLineProperties(jobs[i].item.properties);
        jobs[i].originalPlan = jobs[i].item.selling_plan_allocation
          ? jobs[i].item.selling_plan_allocation.selling_plan.id
          : '';
        var upgrade = await subscriptionUpgrade(jobs[i].item);
        jobs[i].gifts = upgrade.gifts;
        jobs[i].attachMain = upgrade.attachMain;
        jobs[i].mainProps = upgrade.mainProps;
        jobs[i].mainPropsString = upgrade.mainPropsString;
        jobs[i].previousBundleId = upgrade.previousBundleId;
      }
      for (var j = 0; j < jobs.length; j++) {
        var job = jobs[j];
        startedJobs.push(job);
        var changePayload = {
          id: job.key, quantity: job.item.quantity, selling_plan: job.plan
        };
        // OTP lines lack __kaching_bundles — stamp main props so the free
        // gift discount can bind when we add it next.
        if (job.attachMain && job.mainPropsString) {
          var nextProperties = copyLineProperties(job.item.properties);
          nextProperties.__kaching_bundles = job.mainPropsString;
          changePayload.properties = nextProperties;
        }
        cart = await subscriptionCartRequest('cart/change.js', changePayload);

        // Old tier/deal gifts lose their discount after a rebind — remove them.
        if (job.previousBundleId) {
          cart = await removeBundleGiftLines(cart, job.previousBundleId);
        }

        // Give EasyGift a brief window to attach the free gift itself.
        if (job.gifts.length) {
          var beforeGiftQty = job.gifts.reduce(function (sum, gift) {
            return sum + giftQtyMatching(cart, gift);
          }, 0);
          var neededGiftQty = job.gifts.reduce(function (sum, gift) {
            return sum + gift.quantity;
          }, 0);
          var waitStarted = Date.now();
          while (beforeGiftQty < neededGiftQty && Date.now() - waitStarted < 900) {
            await new Promise(function (resolve) { setTimeout(resolve, 150); });
            cart = await subscriptionCartRequest('cart.js');
            beforeGiftQty = job.gifts.reduce(function (sum, gift) {
              return sum + giftQtyMatching(cart, gift);
            }, 0);
          }
        }

        var missing = job.gifts.map(function (gift) {
          var existingQty = giftQtyMatching(cart, gift);
          return Object.assign({}, gift, { quantity: Math.max(0, gift.quantity - existingQty) });
        }).filter(function (gift) { return gift.quantity > 0; });
        if (missing.length) {
          await subscriptionCartRequest('cart/add.js?kaching_bundles=true&partial=true', { items: missing });
        }
        cart = await subscriptionCartRequest('cart.js');

        // Drop paid Kaching gift leftovers for this bundle only (failed discount /
        // EG race). Keep any brush the customer already bought at full price.
        var giftVariantIds = job.gifts.map(function (gift) { return gift.id; });
        if (giftVariantIds.length && job.mainProps && job.mainProps.id) {
          cart = await removePaidKachingGiftLines(cart, giftVariantIds, job.mainProps.id);
        }

        var subscribed = cart.items.find(function (item) {
          if (item.variant_id !== job.item.variant_id) return false;
          if (!item.selling_plan_allocation ||
              String(item.selling_plan_allocation.selling_plan.id) !== String(job.plan)) return false;
          if (job.mainPropsString) {
            return item.properties && item.properties.__kaching_bundles === job.mainPropsString;
          }
          return true;
        });
        if (!subscribed) throw new Error('Could not verify the subscription. Please review your cart.');
        job.gifts.forEach(function (gift) {
          var gifted = cart.items.filter(function (item) {
            return item.variant_id === gift.id && item.properties &&
              item.properties.__kaching_bundles === gift.properties.__kaching_bundles;
          });
          if (gifted.reduce(function (sum, item) { return sum + item.quantity; }, 0) < gift.quantity ||
              gifted.some(function (item) { return item.final_line_price !== 0; })) {
            throw new Error('The free subscription gift could not be verified. Please review your cart.');
          }
        });
        job.committed = true;
      }
      await refreshBag();
      await refreshCartIcon();
      if (window.PUB_SUB_EVENTS && typeof publish === 'function') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'strawberry-bag' });
      }
    } catch (err) {
      console.error('[StrawberryBag] subscription upgrade failed', err);
      for (var r = 0; r < startedJobs.length; r++) {
        if (!startedJobs[r].committed) await rollbackSubscriptionJob(startedJobs[r]);
      }
      await refreshBag();
      showSubscriptionError(getBag() || source, err.message);
    } finally {
      busy = false;
      mutatingFromBag = false;
      window.strawberryBundlePending = false;
      document.dispatchEvent(new CustomEvent('strawberry:bundle-pending'));
      bag = getBag();
      if (bag) bag.classList.remove('is-busy');
    }
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function handleCartIconClick(event) {
    if (!syncActiveState()) return;
    if (event && event.isTrusted === false && !userTouched) return;
    stopEvent(event);
    toggleBag();
  }

  function bindCartIcon() {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    if (icon.__sbIconHandler) {
      icon.removeEventListener('click', icon.__sbIconHandler, true);
    }
    icon.__sbIconHandler = handleCartIconClick;
    icon.addEventListener('click', handleCartIconClick, true);
  }

  function isOpenTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('#cart-icon-bubble, [data-sb-open], .header__icon--cart');
  }

  function onDocClick(event) {
    if (!syncActiveState()) return;
    var trigger = isOpenTrigger(event.target);
    if (!trigger) return;
    if (trigger.closest('[data-sb-bag]')) return;
    handleCartIconClick(event);
  }

  window.addEventListener('click', onDocClick, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeBag();
  });

  var userTouched = false;
  window.addEventListener('pointerdown', function (e) {
    if (e.isTrusted) userTouched = true;
  }, true);
  window.addEventListener('keydown', function (e) {
    if (e.isTrusted) userTouched = true;
  }, true);

  var openTimer = null;
  var refreshTimer = null;

  function scheduleRefresh() {
    if (mutatingFromBag) return;
    if (!syncActiveState()) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshBag();
    }, 80);
  }

  function scheduleOpen() {
    if (mutatingFromBag) return;
    if (!syncActiveState()) return;
    if (!userTouched) {
      scheduleRefresh();
      return;
    }
    clearTimeout(openTimer);
    openTimer = setTimeout(openBag, 80);
  }

  document.addEventListener('cart:refresh', function () {
    scheduleRefresh();
  });

  function bindCartUpdate() {
    if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS || !PUB_SUB_EVENTS.cartUpdate) return;
    if (bindCartUpdate.done) return;
    bindCartUpdate.done = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'strawberry-bag') return;
      if (mutatingFromBag) return;
      var source = event && event.source;
      var fromProductForm = source === 'product-form' || source === 'product-form-component';
      if (fromProductForm && userTouched) scheduleOpen();
      else scheduleRefresh();
    });
  }
  bindCartUpdate();

  if (!window.__sbFetchPatched && typeof window.fetch === 'function') {
    window.__sbFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var method = 'GET';
      try {
        method = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      } catch (e) {}
      var req = origFetch.apply(this, arguments);
      if (method !== 'GET' && /\/cart\/(add|change|update|clear)/i.test(url)) {
        Promise.resolve(req)
          .then(function () {
            if (mutatingFromBag) return;
            var isAdd = /\/cart\/add/i.test(url);
            var isEasyGiftAdd = /[?&]_easygift_internal=true(?:&|$)/i.test(url);
            if (isEasyGiftAdd) {
              scheduleRefresh();
              return;
            }
            if (isAdd && userTouched) scheduleOpen();
            else scheduleRefresh();
          })
          .catch(function () {});
      }
      return req;
    };
  }

  new MutationObserver(function () {
    syncActiveState();
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  function observeBodyClass() {
    if (!document.body || document.body.__sbClassObs) return;
    document.body.__sbClassObs = true;
    new MutationObserver(function () {
      syncActiveState();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function observeCheckoutPending() {
    if (!document.body || document.body.__sbPendingObs) return;
    document.body.__sbPendingObs = true;
    new MutationObserver(function () {
      if (isBundlePending()) syncCheckoutPending();
    }).observe(document.body, { childList: true, subtree: true });
  }

  function patchDawnCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;

    if (!drawer.__sbOpenPatched) {
      drawer.__sbOpenPatched = true;
      var originalOpen = drawer.open.bind(drawer);
      drawer.open = function (triggeredBy) {
        if (syncActiveState()) {
          if (userTouched) openBag();
          else refreshBag();
          return;
        }
        return originalOpen(triggeredBy);
      };
    }

    // Kill header binding that races us — replace with ours
    var icon = document.querySelector('#cart-icon-bubble');
    if (icon && !icon.__sbDawnCleared) {
      icon.__sbDawnCleared = true;
      var cloned = icon.cloneNode(true);
      icon.parentNode.replaceChild(cloned, icon);
      bindCartIcon();
    }
  }

  function boot() {
    bindAllBags();
    syncCheckoutPending();
    syncActiveState();
    fillSocialProof(qs('[data-sb-bag][data-sb-ver="2"]'));
    syncHeaderCountFromBag();
    bindCartIcon();
    patchDawnCartDrawer();
    observeBodyClass();
    observeCheckoutPending();
    bindCartUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 0);
  setTimeout(boot, 400);
  setTimeout(boot, 1200);

  document.addEventListener('strawberry:bundle-pending', syncCheckoutPending);
  window.addEventListener('strawberry:bundle-pending', syncCheckoutPending);

  var igPolls = 0;
  var igPoll = setInterval(function () {
    igPolls += 1;
    syncActiveState();
    if (igPolls >= 40) clearInterval(igPoll);
  }, 250);
})();
